import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector, Renderer2 } from '@angular/core';
import { delayTimeout } from 'src/app/functions/delayTimeout';
import { i18n } from 'src/constants/I18N';
import { AppService } from 'src/app/app.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private injector: Injector
  ) { }

  private _appService: AppService;
  get appService(): AppService {
    if (!this._appService) {
      this._appService = this.injector.get(AppService);
    }
    return this._appService;
  }

  public hasError: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public errorMessage: string;
  public onClose: () => any;

  public async showError(error: HttpErrorResponse, message?: string, onClose?: () => any) {
    this.appService.setIsLoading(false);
    this.hasError.next(true);
    this.onClose = onClose;

    if (message) {
      this.errorMessage = message;
    } else {
      switch(error?.status) {
        case 403:
          if (this.appService.isAuth.getValue()) {
            await this.appService.setAuth(false);
            this.appService.isLoginPopupOpen = true;
            this.errorMessage = "Ваша сессия истекла, введите данные для входа"
          } else {
            // this.errorMessage = "Ошибка авторизации, проверьте правильность введённых данных"
            this.errorMessage = error.error?.message ?? error.message;
          }
          break;
        // case 500:
        //   this.errorMessage = i18n.tr("INTERNAL_ERROR");
        //   break;
        default:
          this.errorMessage = error.error?.message ?? error.message;
          break;
      }
    }


    // await delayTimeout(5000);

    // this.closeError();
  }

  public closeError() {
    this.hasError.next(false);
    this.errorMessage = null;

    if (this.onClose) {
      this.onClose();
      this.onClose = null;
    }

    // this.appService.setIsLoading(false);
  }
}
